






































import {
  Prop,
  Vue,
  Component,
} from "@/shared/vuepack";
import {
  CampaignDecision,
} from "@/shared/types";
import { useEbtoStore } from "@/shared/store/ebto";

@Component({
  components: {}
})

export default class SendConfirmationEmail extends Vue {
  @Prop() decision: CampaignDecision;

  ebtoStore = useEbtoStore();

  isSubmitting = false;
  isResendEmail = false;
  email = "";

  get isSubmitDisabled () {
    return this.isSubmitting === true;
  }

  mounted () {
    this.email = this.ebtoStore.verifiedUser.email;
  }

  showSendEmail () {
    this.isResendEmail = false;
  }

  onSubmit () {
    if (this.isSubmitting) {
      return;
    }

    this.$validator.validateAll()
        .then(result => {
          if (!result) {
            return;
          }

          this.ebtoStore.sendConfirmationEmail({
                campaignId: this.ebtoStore.campaignId,
                userId: this.ebtoStore.verifiedUser.userId,
                email: this.email,
                decision: this.decision
              })
              .then(() => {
                this.isSubmitting = false;
                this.isResendEmail = true;
              });
        });
  }
}
